import getWorkflowStepBranchGroups from '@/lib/workflows/getWorkflowStepBranchGroups.js';

// Injects app icon, name and published version onto workflow definition steps by joining app metadata (by app id or slug), recursing into
// children and branches. Definition steps don't store icon/name; this is how the editor (and run logs) resolve them.
const addStepAppMetadata = (steps, metadataById, metadataBySlug) => {
  return steps.map((step) => {
    const appId = String(step?.appId || step?.app?.id || '').trim();
    const slug = String(step?.appSlug || step?.appRef || step?.app?.slug || '')
      .trim()
      .toLowerCase();
    const meta = (appId ? metadataById[appId] || null : null) || (slug ? metadataBySlug[slug] || null : null);
    const icon = meta?.icon || null;
    const appName = meta?.name || null;
    // The app's published version, so a step held on another one can say so (a step keeps its version when one is published).
    const appPublishedVersion = meta?.publishedVersion || null;
    const children = Array.isArray(step?.children) && step.children.length > 0 ? addStepAppMetadata(step.children, metadataById, metadataBySlug) : step?.children;
    let branches = step?.branches;
    let branchesByKey = step?.branchesByKey;

    for (const branch of getWorkflowStepBranchGroups(step)) {
      if (branch.steps.length < 1) {
        continue;
      }

      const hydratedBranchSteps = addStepAppMetadata(branch.steps, metadataById, metadataBySlug);

      if (step?.branchesByKey && typeof step.branchesByKey === 'object' && !Array.isArray(step.branchesByKey)) {
        branchesByKey = { ...(branchesByKey || {}), [branch.key]: hydratedBranchSteps };
      } else if (step?.branches && typeof step.branches === 'object' && !Array.isArray(step.branches)) {
        branches = { ...(branches || {}), [branch.key]: hydratedBranchSteps };
      }
    }

    const changed = icon || appName || appPublishedVersion || children !== step?.children || branches !== step?.branches || branchesByKey !== step?.branchesByKey;
    return changed
      ? {
          ...step,
          ...(icon ? { appIcon: icon } : {}),
          ...(appName ? { appName } : {}),
          ...(appPublishedVersion ? { appPublishedVersion } : {}),
          ...(children !== step?.children ? { children } : {}),
          ...(branches !== step?.branches ? { branches } : {}),
          ...(branchesByKey !== step?.branchesByKey ? { branchesByKey } : {})
        }
      : step;
  });
};

export default addStepAppMetadata;
